var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quotes-container"},[_c('img',{staticClass:"quote-image",attrs:{"src":require("./img/nextstep.png"),"alt":"image"}})])
}]

export { render, staticRenderFns }